/**
 *
 * @param modifierDefinitionProps
 */
export function simulateModifierContract(modifierDefinitionProps) {
    return Object.assign({ availableToMulticlass: null, bonusTypes: null, componentId: -1, componentTypeId: -1, dice: null, duration: null, entityId: null, entityTypeId: null, fixedValue: null, friendlySubtypeName: null, friendlyTypeName: null, id: null, isGranted: true, modifierSubTypeId: -1, modifierTypeId: -1, requiresAttunement: false, restriction: null, statId: null, subType: null, type: null, value: null }, modifierDefinitionProps);
}
